import React from 'react'
import {
    NavBar
} from 'antd-mobile';
// import back from '../../images/back.png'
import back from '../../images/back2.png'
import './index.less'
import { isWeChat } from '../../utils/utils'

export default class Header extends React.Component{
    constructor(props) {
        super(props)
    }

    //如果历史记录小于1，返回指定页面
    goHistoryBack = () => {
        if (window.history.length > 1) {
            window.history.back(-1);
        }
    }

    render() {
        const { name, rightMenu, leftMenu, appIsShow  } = this.props;
        let clinet = isWeChat()
        return (
            ((clinet === 1 || clinet === 3 || clinet === 4 || clinet === 5) && appIsShow != 1) ? <div />
            :
            <NavBar
                mode = "dark"
                onLeftClick={() => this.goHistoryBack()}
                icon={ leftMenu ? leftMenu : <img src={back} className="back-img" alt="" /> }
                className = "header"
                rightContent={rightMenu ? rightMenu : ''}>
                {name}
            </NavBar>
        );
    }
}